import {createUseStyles} from "react-jss";
import {colors} from "../../theme";

export const useStyles = createUseStyles({
    wrapper: {
        position:"relative",
        maxWidth: 300,
        width: "100%",
    },
    label: {
        position:"relative",
        display: "block",
        marginBottom: 5,
        marginRight: 30,
        overflow: "hidden",
    },
    value: {
        position: "absolute",
        right: 0,
        top: 0,
        background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%)",
        paddingLeft: 20,
        paddingRight: 2,
    },
    bar: {
        position: "relative",
        display: "block",
        width: "100%",
        marginTop: 2,
        height: 6,
        minWidth: 4,
        borderBottomWidth: 6,
        borderBottomStyle: "solid",
        borderBottomColor: colors.neutral30,
        borderRightWidth: 2,
        borderRightStyle: "solid",
        borderRightColor: colors.neutral30,
    },
    inner: {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: -3,
        width: "0%",
        backgroundColor: colors.primary,
        display: "inline-block",
    },
})